import { z } from 'zod';
/**
 * The browser tab that sent a request, as a random id the tab makes once. It travels with the
 * request into each service, so a live event can name the tab that caused it. corp-api then does
 * not send a tab the events of its own requests: the tab's own mutation already refetched.
 */
export const LIVE_ORIGIN_HEADER = 'x-live-origin';
const LiveOriginSchema = z.uuid();
/** The tab id in a request's {@link LIVE_ORIGIN_HEADER}, or undefined for anything that is not one. */
export function readLiveOrigin(header) {
    const value = typeof header === 'string' ? header : header?.[0];
    const parsed = LiveOriginSchema.safeParse(value);
    return parsed.success ? parsed.data : undefined;
}
//# sourceMappingURL=LiveOrigin.js.map